import * as timeago from 'timeago.js'
import timeagoLocaleFr from 'timeago.js/lib/lang/fr'
export { timeago }
export { timeagoLocaleFr }
